/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SortDirection } from '../../models/sort-direction';
import { TagList } from '../../models/tag-list';

export interface SearchTags$Any$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the tag name
 *   * ALIAS : the tag alias
 *   * UNIT : the tag unit
 *   * VALUE_TYPE : the tag value type
 *   * STATION_CODE: the tag station
 *   * LAST_VALUES_LAST_VALUE: the tag realtime last value
 *   * LAST_VALUES_LAST_VALUE_DATETIME: the tag realtime last value date and time
 */
  sortFieldName?: 'NAME' | 'ALIAS' | 'UNIT' | 'VALUE_TYPE' | 'STATION_CODE' | 'LAST_VALUES_LAST_VALUE' | 'LAST_VALUES_LAST_VALUE_DATETIME';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;

/**
 * The search text to filter API
 */
  search?: string;

/**
 * true returns only tags with a station, false returns only tags without a station, null returns all
 */
  tagsWithStation?: boolean;
  
    /**
     * Body for search graph tags
     */
    body?: any
}

export function searchTags$Any(http: HttpClient, rootUrl: string, params?: SearchTags$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<TagList>> {
  const rb = new RequestBuilder(rootUrl, searchTags$Any.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('search', params.search, {});
    rb.query('tagsWithStation', params.tagsWithStation, {});
    rb.body(params.body, 'application/octet-stream');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagList>;
    })
  );
}

searchTags$Any.PATH = '/tags/search';
